export const getLineChartSymbol = index => {
  const symbols = ['circle', 'square', 'triangle', 'diamond', 'triangle-down'];
  return symbols[index % symbols.length];
};

export const makeObjectOutOfArrays = (arr1 = [], arr2 = []) => {
  return Object.fromEntries(arr1.map((col, i) => [col, arr2[i]]));
};
const dummyAnnotations = [
  {
    draggable: '',
    labels: [
      {
        offsetY: 0,
        offsetX: 0,
        point: { x: 0, y: 0 },
        text: '8944',
        borderWidth: 0,
        padding: 0,
        shape: null,
        align: 'center',
        backgroundColor: 'transparent',
        verticalAlign: 'middle',
        verticalAlign: 'middle',
        style: { color: '#000', fontSize: '30px', fontWeight: 'bold' }
      }
    ]
  },
  {
    draggable: '',
    labels: [
      {
        offsetY: 40,
        offsetX: 0,
        point: { x: 0, y: 0 },
        text: 'centerLabel',
        borderWidth: 0,
        padding: 0,
        shape: null,
        align: 'center',
        backgroundColor: 'transparent',
        verticalAlign: 'middle',
        verticalAlign: 'middle',
        style: { color: '#666', fontSize: '14px' }
      }
    ]
  },
  {
    draggable: '',
    labels: [
      {
        offsetY: 120,
        offsetX: -40,
        point: { x: 0, y: 0 },
        text: 2,
        borderWidth: 0,
        padding: 0,
        shape: null,
        align: 'center',
        backgroundColor: 'transparent',
        verticalAlign: 'middle',
        verticalAlign: 'middle',
        style: { color: '#333', fontSize: '14px', fontWeight: '500' }
      }
    ]
  },
  {
    draggable: '',
    labels: [
      {
        offsetY: 120,
        offsetX: 40,
        point: { x: 0, y: 0 },
        text: 2,
        borderWidth: 0,
        padding: 0,
        shape: null,
        align: 'center',
        backgroundColor: 'transparent',
        verticalAlign: 'middle',
        verticalAlign: 'middle',
        style: { color: '#333', fontSize: '14px', fontWeight: '500' }
      }
    ]
  }
];

export const handleHighChartsExport = (exportType, chartRef, data) => {
  switch (exportType.id) {
    case 'pdf':
      exportWithFullWidth(
        chartRef.current?.chart?.exportChart(
          {
            type: 'application/pdf',
            filename: data?.title,
            width: 800
          },
          {
            chart: {
              backgroundColor: '#FFFFFF',
              borderWidth: 2,
              borderColor: '#E0E0E0',
              borderRadius: 16,
              marginTop: 80
            },
            title: {
              text: data?.title,
              align: 'left',
              x: 10,
              y: 50,
              style: {
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#0B1F35'
              }
            },
            subtitle: {
              text: data?.subTitle,
              align: 'left',
              x: 10,
              y: 80,
              style: {
                fontSize: '14px',
                color: '#4F5B67'
              }
            },
            exporting: {
              chartOptions: {
                chart: {
                  marginTop: 120
                }
              }
            }
          }
        )
      );
      break;

    case 'img':
      chartRef.current?.chart?.exportChart(
        {
          type: 'image/png',
          filename: data?.title
        },
        {
          chart: {
            backgroundColor: '#FFFFFF',
            borderWidth: 2,
            borderColor: '#E0E0E0',
            borderRadius: 16,
            marginTop: 80
          },
          title: {
            text: data?.title,
            align: 'left',
            x: 10,
            y: 40,
            style: {
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#0B1F35'
            }
          },
          subtitle: {
            text: data?.subTitle,
            align: 'left',
            x: 10,
            y: 70,
            style: {
              fontSize: '14px',
              color: '#4F5B67'
            }
          },
          exporting: {
            chartOptions: {
              chart: {
                marginTop: 120
              }
            }
          }
        }
      );
      break;
    case 'ppt':
      exportWithFullWidth(
        chartRef.current?.chart?.exportChart(
          {
            type: 'application/vnd.openxmlformats-officedocument.pptx',
            filename: data?.title
          },
          {
            chart: {
              backgroundColor: '#FFFFFF',
              marginTop: 120
            },
            title: {
              text: data?.title,
              align: 'left',
              x: 20,
              y: 40,
              style: {
                fontSize: '20px',
                fontWeight: 'bold',
                color: '#0B1F35'
              }
            },
            subtitle: {
              text: data?.subTitle,
              align: 'left',
              x: 20,
              y: 70,
              style: {
                fontSize: '14px',
                color: '#4F5B67'
              }
            },
            exporting: {
              sourceWidth: 800,
              sourceHeight: 600,
              chartOptions: {
                chart: {
                  marginTop: 120
                }
              }
            }
          }
        )
      );
      break;

    case 'xls':
      chartRef.current?.chart?.exportChart({ type: 'image/svg+xml' });
      const chart = chartRef.current?.chart;
      const csv = chart?.getCSV();
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `${data?.title}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      break;

    default:
      break;
  }
};

const exportWithFullWidth = (chart, exportConfig, optionsConfig) => {
  if (!chart) return;

  // Save existing scrollablePlotArea
  const oldScrollable = chart.options.chart.scrollablePlotArea;

  // 1. Disable scroll before export
  chart.update({
    chart: {
      scrollablePlotArea: null
    }
  });

  // 2. Trigger export
  chart.exportChart(exportConfig, optionsConfig);

  // 3. Restore scroll after export
  setTimeout(() => {
    chart.update({
      chart: { scrollablePlotArea: oldScrollable }
    });
  }, 500);
};
